exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ":root{--font-family-base:\"Segoe UI\",\"HelveticaNeue-Light\",sans-serif;--max-content-width:1080px;--max-container-width:100%;--screen-xs-min:480px;--screen-sm-min:768px;--screen-md-min:992px;--screen-lg-min:1200px;--border-color:#dce0e0;--background-color:#fff;--btn-color:#404040;--btn-primary-bg:#0667b3;--btn-primary-color:#fff;--btn-primary-hover-bg:#58595b;--btn-secondary-bg:#0667b2;--btn-secondary-color:#fff;--btn-secondary-hover-bg:#0667b2}._2lmHp{margin:0 auto;padding-top:30px;max-width:1080px;max-width:var(--max-content-width)}._3Ge9y{max-width:1080px;width:100%;display:block;margin:0 auto}._1qwiI{font-size:16px;border-bottom:1px solid #dce0e0;background-color:#f5f5f5}._1BZIg,._1qwiI{border-radius:0;width:100%;display:block;color:#404040}._1BZIg{font-size:14px;line-height:1.43}@media screen and (max-width:768px){._2UOVI{padding:0;margin-top:20px}}", ""]);

// exports
exports.locals = {
	"container": "_2lmHp",
	"landingContainer": "_3Ge9y",
	"panelHeader": "_1qwiI",
	"panelEmpty": "_1BZIg",
	"smPadding": "_2UOVI"
};